import { Injectable, Signal, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Profile, UpdateProfile } from '@mp/auth/profile/domain';

import { ProfileActions, ProfileLoadFailure } from './profile.actions';
import { selectProfile, selectProfileLoadFailure } from './profile.selectors';

@Injectable({ providedIn: 'root' })
export class ProfileFacade {
  private readonly store$ = inject(Store);

  readonly profile: Signal<Profile | null> = this.store$.selectSignal(selectProfile);

  readonly profile$: Observable<Profile | null> = this.store$.select(selectProfile);

  /**
   * Status und Ursache des endgültig fehlgeschlagenen Profil-Abrufs (nach den Wiederholungsversuchen),
   * sonst `null`.
   */
  readonly profileLoadFailure$: Observable<ProfileLoadFailure | null> = this.store$.select(selectProfileLoadFailure);

  fetchProfile(): void {
    this.store$.dispatch(ProfileActions.fetchProfile());
  }

  updateProfile(dto: UpdateProfile): void {
    this.store$.dispatch(ProfileActions.updateProfile({ dto }));
  }
}
